import React from 'react';

const Foodplan = () => {
  return (
    <div>
      <h1>Madplan</h1>
    </div>
  )
}

export default Foodplan